import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1021"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m8.608 12.47 6.353-1.631-3.664-.783 1.619-2.578a.792.792 0 0 0 .122-.444l-.088-3.132a.79.79 0 0 0-.371-.649L8.506.691A.794.794 0 0 0 7.76.638L4.898 1.916a.802.802 0 0 0-.347.3L2.649 5.215a.793.793 0 1 0 1.342.847l.12-.19 5.692 3.58-.143.254-5.885-1.257 2.459 2.078L0 12.189l9.089 3.481L16 14.371 8.608 12.47zM5.76 5.475a.779.779 0 1 1 .043-1.557.779.779 0 0 1-.043 1.557zm3.576 1.942a.779.779 0 1 1 1.557.043.779.779 0 0 1-1.557-.043z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }